/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Art_Row_4Inputs */

const en_svc_n8n_art_row_4 = /** @type {(inputs: Svc_N8n_Art_Row_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly report draft`)
};

const lv_svc_n8n_art_row_4 = /** @type {(inputs: Svc_N8n_Art_Row_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedēļas atskaites melnraksts`)
};

/**
* | output |
* | --- |
* | "Weekly report draft" |
*
* @param {Svc_N8n_Art_Row_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_art_row_4 = /** @type {((inputs?: Svc_N8n_Art_Row_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Art_Row_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_art_row_4(inputs)
	return en_svc_n8n_art_row_4(inputs)
});